import type { Interest } from '@/components/onboarding/types';
import type { Language } from '@/i18n/translations';

export const INTEREST_HINTS: Record<Interest, Partial<Record<Language, string>> & { en: string }> = {
  'ai-assistant': {
    sv: 'Användaren är nyfiken på AI-driven workflow-generering — du får prata om dina egna capabilities.',
    en: 'The user is curious about AI-driven workflow generation — you may discuss your own capabilities.',
  },
  '3d-view': {
    sv: 'Föreslå 3D-vy när workflowet har flera sheets och arkitektur ska kommuniceras.',
    en: 'Suggest the 3D view when the workflow spans multiple sheets and you need to communicate architecture.',
  },
  'multi-sheet': {
    sv: 'Föreslå att dela upp i flera sheets om workflowet växer över ~30 blocks.',
    en: 'Suggest splitting into multiple sheets when the workflow grows beyond ~30 blocks.',
  },
  'export-share': {
    sv: 'Påminn om PNG/SVG-export och cloud workspaces när det passar.',
    en: 'Remind about PNG/SVG export and cloud workspaces when relevant.',
  },
  shortcuts: {
    sv: 'Nämn tangentbord-shortcuts (Ctrl+S, Ctrl+Z, Del) när det snabbar upp arbetet.',
    en: 'Mention keyboard shortcuts (Ctrl+S, Ctrl+Z, Del) when they speed up work.',
  },
  'process-motor': {
    sv: 'Användaren är intresserad av process-motorn (run workflows som processer). Föreslå manual triggers, schedules eller webhooks när det passar.',
    en: 'The user is interested in the process engine (running workflows as processes). Suggest manual triggers, schedules or webhooks when relevant.',
  },
  enterprise: {
    sv: 'Användaren har Enterprise-tier — du kan föreslå API-nycklar, scheduled runs och webhooks utan tier-gate-warning.',
    en: 'The user has Enterprise tier — you can suggest API keys, scheduled runs and webhooks without tier-gate warnings.',
  },
};

export function buildInterestsLayer(interests: Interest[], lang: Language): string {
  if (!interests.length) return '';
  const hints = interests.map(i => INTEREST_HINTS[i][lang] ?? INTEREST_HINTS[i].en).join(' ');
  const prefix = lang === 'sv'
    ? 'Du FÅR proaktivt föreslå följande när det ger tydligt värde, men tvinga aldrig in dem: '
    : 'You MAY proactively suggest these when they clearly add value, but never force them: ';
  return prefix + hints;
}
